<template>
  <div id="wrapper">
    <div id="content">
      <div v-if="showToolbar" class="toolbar">
        <tool type="home" @onClick="setTool"></tool>
        <tool type="measure" @onClick="setTool"></tool>
        <tool type="info" @onClick="setTool"></tool>
        <tool type="draw" @onClick="setTool"></tool>
        <tool type="files" @onClick="setTool"></tool>
        <tool type="comments" @onClick="setTool"></tool>
        <tool type="search" @onClick="setTool"></tool>
        <tool type="street" @onClick="setTool"></tool>
      </div>
      <div id="map" class="map"></div>
      <Deceased v-if="showSection('deceased')" />
      <div
        v-if="showSidebar"
        style="width:60px;height: calc(100vh - 35px);display:flex;flex-direction:column;"
      >
        <tool type="home" @onClick="setTool"></tool>
      </div>
    </div>
    <nav v-if="showSidebar" id="sidebar" style="display:block;">
      <p>
        <router-link :to="{ name: 'logout' }">Logout</router-link>
      </p>
      <div style="position: absolute;bottom:10px;">
        <p class="pointer" v-on:click.prevent="setProjection">
          {{ $t("projection") }}: EPSG:{{ projection }}
        </p>
      </div>
    </nav>
    <footer-area v-if="showFooter"></footer-area>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus";
import Tool from "@/components/shared/Tool.vue";
import FooterArea from "@/components/shared/FooterArea.vue";
import Deceased from "@/modules/deceased/Deceased.vue";
import * as type from "../../mutationTypes.js";
import WKT from "ol/format/WKT.js";
import { fromLonLat } from "ol/proj.js";
import { unByKey } from "ol/Observable.js";
import Overlay from "ol/Overlay.js";
import { Draw, DragBox } from "ol/interaction.js";

import proj4 from "proj4";
import { register } from "ol/proj/proj4.js";
import {
  map as mapUtils,
  layer as layerUtils,
  formatLength,
  formatArea
} from "../../utils/map/index.js";
import utils from "../../utils/map";
import { Polygon, LineString } from "ol/geom.js";
import md5 from "blueimp-md5";
import { assignIn } from "lodash";

import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style.js";

const ResizeSensor = require("css-element-queries/src/ResizeSensor");

export default {
  name: "map",
  components: {
    Tool,
    FooterArea,
    Deceased
  },
  data: function() {
    return {
      loading: true,
      map: null,
      parcel: "",
      tool: "",
      interactions: [],
      layers: [],
      measure: {
        type: "LineString",
        sketch: null,
        helpTooltipElement: null,
        helpTooltip: null,
        measureTooltipElement: null,
        measureTooltip: null,
        continuePolygonMsg: "Click to continue drawing the polygon",
        continueLineMsg: "Click to continue drawing the line"
      },
      layerDialog: {
        show: false
      }
    };
  },
  watch: {},
  computed: {
    pov() {
      return this.$store.state.user.pov;
    },
    projection() {
      const proj = this.$store.state.user.config.projection;

      if (this.mousePositionControl) {
        this.mousePositionControl.setProjection("EPSG:" + proj);
      }

      return proj;
    },
    baseLayer() {
      return this.$store.state.user.settings.baseLayer;
    },
    showToolbar() {
      return this.showSection("toolbar");
    },
    showSidebar() {
      return false;
    },
    showFooter() {
      return this.showSection("footer");
    }
  },
  methods: {
    showSection(section) {
      console.log("section", section);
      try {
        return (
          this.$store.getters["view/view"].sections.indexOf(section) !== -1
        );
      } catch (error) {
        return null;
      }
    },
    setTool(tool) {
      this.showToolbar = true;
      console.log("tool", tool);
      mapUtils.cleanup(this.map);
      this.tool = tool;

      if (this.tool === "home") {
        this.map.getView().animate({
          center: fromLonLat([16.075, 46.655]),
          zoom: 12,
          duration: 2000
        });
      } else if (this.tool === "measure") {
        const layer = layerUtils.addMeasureLayer(this.map);

        function createHelpTooltip() {
          if (this.measure.helpTooltipElement) {
            this.measure.helpTooltipElement.parentNode.removeChild(
              this.measure.helpTooltipElement
            );
          }
          this.measure.helpTooltipElement = document.createElement("div");
          this.measure.helpTooltipElement.className = "tooltip hidden";
          this.measure.helpTooltip = new Overlay({
            element: this.measure.helpTooltipElement,
            offset: [30, 0],
            positioning: "center-left"
          });

          this.map.addOverlay(this.measure.helpTooltip);
        }

        function createMeasureTooltip() {
          if (this.measure.measureTooltipElement) {
            this.measure.measureTooltipElement.parentNode.removeChild(
              this.measure.measureTooltipElement
            );
          }
          this.measure.measureTooltipElement = document.createElement("div");
          this.measure.measureTooltipElement.className =
            "tooltip tooltip-measure show";
          this.measure.measureTooltip = new Overlay({
            element: this.measure.measureTooltipElement,
            offset: [0, 10],
            positioning: "bottom-center"
          });

          this.map.addOverlay(this.measure.measureTooltip);
        }

        const draw = new Draw({
          source: layer.getSource(),
          type: this.measure.type,
          style: new Style({
            fill: new Fill({
              color: "rgba(255, 255, 255, 0.2)"
            }),
            stroke: new Stroke({
              color: "rgba(0, 0, 0, 0.5)",
              lineDash: [10, 10],
              width: 2
            }),
            image: new CircleStyle({
              radius: 5,
              stroke: new Stroke({
                color: "rgba(0, 0, 0, 0.7)"
              }),
              fill: new Fill({
                color: "rgba(255, 255, 255, 0.2)"
              })
            })
          })
        });

        this.map.addInteraction(draw);

        createMeasureTooltip.call(this);
        createHelpTooltip.call(this);

        var listener;
        const self = this;
        draw.on(
          "drawstart",
          function(evt) {
            console.log("measure", self.measure);
            self.measure.sketch = evt.feature;

            /** @type {module:ol/coordinate~Coordinate|undefined} */
            const tooltipCoord = evt.coordinate;
            console.log("tooltipCoord", tooltipCoord);

            listener = self.measure.sketch
              .getGeometry()
              .on("change", function(evt) {
                const geom = evt.target;
                let output;
                if (geom instanceof Polygon) {
                  output = formatArea(geom);
                  self.measure.tooltipCoord = geom
                    .getInteriorPoint()
                    .getCoordinates();
                } else if (geom instanceof LineString) {
                  output = formatLength(geom);
                  self.measure.tooltipCoord = geom.getLastCoordinate();
                }
                console.log("output", output);
                self.measure.measureTooltipElement.innerHTML = output;
                self.measure.measureTooltip.setPosition(
                  self.measure.tooltipCoord
                );
              });
          },
          this
        );

        draw.on(
          "drawend",
          function() {
            self.measure.measureTooltipElement.className =
              "tooltip tooltip-static";
            self.measure.measureTooltip.setOffset([0, -7]);
            // unset sketch
            self.measure.sketch = null;
            // unset tooltip so that a new one can be created
            self.measure.measureTooltipElement = null;
            createMeasureTooltip.call(self);
            unByKey(listener);
          },
          this
        );
      } else if (this.tool === "info") {
        // a DragBox interaction used to select features by drawing boxes
        const dragBox = new DragBox();

        this.map.addInteraction(dragBox);

        dragBox.on("boxend", function() {
          const extent = dragBox.getGeometry().getExtent();
          console.log("selected extent", extent);
        });

        dragBox.on("boxstart", function() {
          console.log("starting selection");
        });
      } else if (this.tool === "draw") {
        // TODO: Load drawings to be editable (WFS? (extent based))
        const options = {
          type: "LineString"
        };

        mapUtils.setDrawing(this.map, options, geom => {
          // TODO: Dialog with drawing info management
          console.log("geom", geom);
          /*return drawService
                        .draw({ geom })
                        .then(() => {
                            mapUtils.cleanup(this.map);
                            layerUtils.reloadMainLayer(this.map);
                        })
                        .catch(err => {
                            console.log("error", err);
                        });*/
        });
      } else {
        alert("Nothing to do");
      }
    },
    setPov() {
      this.$store.dispatch({
        type: type.setPov,
        pov: {
          center: this.map.getView().getCenter(),
          zoom: this.map.getView().getZoom()
        }
      });
    },
    setProjection() {
      const projection =
        this.$store.state.user.config.projection != 4326 ? 4326 : 3794;

      this.$store.dispatch(type.setProjection, projection);
    },

    resizeMap() {
      if (!this.map) {
        return;
      }

      const center = this.map.getView().getCenter();
      setTimeout(() => {
        this.map.updateSize();
        this.map.getView().setCenter(center);
      }, 200);
    }
  },
  mounted() {
    proj4.defs(
      "EPSG:3912",
      "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500375 +y_0=-4999962.5 +ellps=bessel +units=m +no_defs"
    );
    proj4.defs(
      "EPSG:3787",
      "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +towgs84=430.8554,121.4779,459.6256,4.3787,4.3716,-11.9863,17.3666 +units=m +no_defs"
    );
    proj4.defs(
      "EPSG:3794",
      "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
    );

    register(proj4);

    const spot = this.$store.state.view.spot;
    console.log('spot', spot);

    this.$store.dispatch("user/getSettings").then(settings => {
      const { view, layers, mapfile, extra_layers } = settings;
      const viewData = assignIn({}, view);

      if (spot.center) {
        const wkt = new WKT();
        const feature = wkt.readFeature(spot.center, {
          dataProjection: `EPSG:${spot.srid}`,
          featureProjection: `EPSG:${view.projection}`
        });

        viewData.center = feature.getGeometry().flatCoordinates;
        viewData.zoom = utils.getNearestZoom(spot.scale);
      }

      const hash = md5(settings.user.id);

      this.map = mapUtils.initMap.call(this, {
        view: viewData,
        layers: (spot && spot.layers) || layers,
        mapfile,
        extra_layers,
        hash
      });

      // this.$i18n.locale = settings.language;
    });

    const element = document.getElementById("map");
    new ResizeSensor(element, () => {
      eventBus.$emit("viewport-changed", element.clientWidth);
      this.resizeMap();
    });

    eventBus.$on("show", item => {
      const wkt = new WKT();
      const feature = wkt.readFeature(item.wkt, {
        dataProjection: "EPSG:3794",
        featureProjection: "EPSG:3857"
      });

      feature.set("gid", item.gid);

      const drawLayer = layerUtils.getOrCreateLayer("draw", {
        map: this.map,
        clear: true
      });

      drawLayer.getSource().addFeature(feature);

      mapUtils.fitView(this.map, { layer: drawLayer, maxZoom: 20 });
    });
  }
};
</script>

<style scoped lang="stylus">
.wrapper {
  display: flex;
  width: 100%;
  /* overflow: hidden; */
}

#sidebar {
  width: 250px;
  position: fixed;
  top: 0;
  right: 0;
  height: calc(100vh - 35px);
  z-index: 999;
  background: #3c4858;
  color: #fff;
  transition: all 0.3s;
}

#content {
  width: 100%;
  height: calc(100vh - 35px);
  display: flex;
}

.toolbar {
  display: flex;
  height: 56px;
}

.map {
  background-color: white;
  flex-grow: 1;
}

.map:-moz-full-screen {
  height: 100%;
}

.map:-webkit-full-screen {
  height: 100%;
}

.map:-ms-fullscreen {
  height: 100%;
}

.map:fullscreen {
  height: 100%;
}

.left {
  text-align: left;
}

.pointer {
  cursor: pointer;
}

.margin-side {
    margin-left: 10px;
    margin-right: 10px;
}

/* Measure related func */
.tooltip {
    position: relative;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    color: white;
    padding: 4px 8px;
    opacity: 0.7;
    white-space: nowrap;
}
.tooltip-measure {
    opacity: 1;
    font-weight: bold;
}
.tooltip-static {
    background-color: #ffcc33;
    color: black;
    border: 1px solid white;
}
.tooltip-measure:before,
.tooltip-static:before {
    border-top: 6px solid rgba(0, 0, 0, 0.5);
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    content: "";
    position: absolute;
    bottom: -6px;
    margin-left: -7px;
    left: 50%;
}
.tooltip-static:before {
    border-top-color: #ffcc33;
}
.tooltip.show {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    color: white;
    padding: 4px 8px;
    opacity: 0.7;
    white-space: nowrap;
}
</style>
